export default __webpack_public_path__ + "static/media/Active_Dashboard.670df0d1.svg";